import { Component, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { CartState } from '../../state/cart.state';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { CheckoutModalComponent } from '../checkout-modal/checkout-modal.component';
import { CartActions } from '../../state/cart.actions';
import { GoogleAnalyticsService } from '@hakimio/ngx-google-analytics';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCartShopping } from '@fortawesome/pro-solid-svg-icons';

@Component({
    selector: 'app-cart',
    imports: [FontAwesomeModule],
    templateUrl: './cart.component.html',
    styleUrl: './cart.component.scss',
    standalone:true
})
export class CartComponent {
  private readonly gaService = inject(GoogleAnalyticsService);
  private modalService = inject(NgbModal);
  list: any;
  iconCart = faCartShopping;

  constructor(
    private store: Store,
    config: NgbModalConfig,
  ) {
    config.backdrop = 'static';
    config.keyboard = false;
    this.store.select(CartState.getList).subscribe((res) => {
      this.list = res.length;

    });
  }

  openCheckout() {


    // modalRef.close(res => {
    //   
    //   this.store.dispatch(new CartActions.SetShipping(0));
    // });
    
    if (this.list >= 1) {
      this.gaService.event('click_popup', {
        category: 'popUp_Checkout',
        label: 'Checkout',
      });
      const modalRef = this.modalService.open(CheckoutModalComponent, { size: 'xl' });
      modalRef.hidden.subscribe((res) => {
        this.store.dispatch(new CartActions.SetShipping(0));
      });
    }

  }
}
